import { render, staticRenderFns } from "./CollegeUserForgetPassword.vue?vue&type=template&id=459b91b2&scoped=true&"
import script from "./CollegeUserForgetPassword.vue?vue&type=script&lang=js&"
export * from "./CollegeUserForgetPassword.vue?vue&type=script&lang=js&"
import style0 from "./CollegeUserForgetPassword.vue?vue&type=style&index=0&id=459b91b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459b91b2",
  null
  
)

export default component.exports